module.exports = __webpack_public_path__ + "media/images/flags/NA-445f59f7507eea0d862a12408095d452.svg";